__webpack_require__.p = "https://www.fxa.bluelife.dev/settings/prod/";